// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__LilbX","icon":"SortAdornment_icon__3DVIJ","up":"SortAdornment_up__-WB-l","down":"SortAdornment_down__30cvu","active":"SortAdornment_active__12DUv"};